export default __webpack_public_path__ + "static/media/two-people-looking-for.6c9fca20.png";